import React, { useState } from 'react';
import styled, { css, keyframes } from 'styled-components';
import { Info } from 'components/info'

const Container = styled.div`
  display: flex;
  position: relative;
  width:48px;
  height: var(--size-large);
  background-color: #e6e6e6;
  border-radius: 30px;
  transition: 0.4s;
  margin-bottom: var(--size-small);
  text-align: center;
  z-index: 2;
`;

const sliderAnim = keyframes`
  0% {
    transform: translateX(1px);
  }
  100% {
    transform: translateX(23.5px);
  }
`;

const sliderAnimBack = keyframes`
   0% {
        transform: translateX(23.5px);
    }
    100% {
        transform: translateX(1px);
    }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--disabled);
  border-radius: 34px;
  transition: 0.5s;
  &:before {
    position: absolute;
    content: "";
    height: 17.8px;
    width: 17.8px;
    left: 3px;
    bottom: 1.8px;
    background-color: var(--font-color);
    border-radius: 50%;
    transition: 0.5s;
    animation: ${({ checked }: { checked: boolean }) =>
        checked ? css`${sliderAnim} 0.5s forwards` : css`${sliderAnimBack} 0.3s forwards`}; 
  }
  @media (max-width: 1269px) {
        &:before {
            bottom: 2px;
            height: 20px;
            width: 20px;
            left: 1.7px;
        }
  }
`;

const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${Slider} {
    background: linear-gradient( 90deg, var(--secondary-dark), var(--primary-light))
  }

  &:checked + ${Slider}:before {
    transform: translateX(24px);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`

const Label = styled.label`
  position: absolute;
  top: 50%;
  left: ${({ checked }: { checked: boolean }) => (checked ? '58px' : '50px')};
  transform: translateY(-50%);
  align-items: center;
  justify-content: center;
  font-size: var(--size-medium);
  min-height: 20px;
  color: var(--font-color);
  font-weight: var(--font-weight-semi-bold);
  transition: all 0.5s ease;
  white-space: nowrap;
  display: flex;
  animation: ${({ checked }: { checked: boolean }) => checked ? '' : css`${fadeOut} 0.25s ease forwards`};
`;


const IconBuyDemand = styled(Info)`
    
    animation: ${({ checked }: { checked: boolean }) =>
        checked ? css`${sliderAnim} 0.4s forwards` : css`${sliderAnimBack} 0.4s forwards`};
    
    .infowidth {
        width: 140px;
        z-index: 5;
    }

    .infohover {
        top: 0px;
        left:0px;
        margin-top: 25px;
        width: 140px;
        text-align: left;
        font-size: var(--size-medium);
    }
`

const LabelInfo = styled.div`
    display:flex;
    width: 100vh;
`;

const ContInfo = styled.div`
    padding-left: ${({ checked }: { checked: boolean }) => (checked ? '138px' : '45px')};
    /*padding-right: 140px;*/
    display:flex;
    width: 100%;
`;

interface Props {
    checked?: boolean
    labelOn?: string
    info?: string
    onChange?: (checked: boolean) => void
}

export const Switch: React.FC<Props> = ({ labelOn="", info, onChange }) => {

    const [isChecked, setChecked] = useState(false)
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked)
    };
    const handleSwitchClick = (event: React.MouseEvent<HTMLSpanElement>) => {
        event.stopPropagation()
        setChecked(!isChecked)
        onChange && onChange(!isChecked)
    };

    return (
        <Container >
            <Checkbox checked={isChecked} onChange={handleChange} />
            <Slider checked={isChecked} onClick={handleSwitchClick} />
            <LabelInfo>
            <Label checked={isChecked} >{labelOn}</Label>
            {info && <ContInfo checked={isChecked}>
                    <IconBuyDemand checked={isChecked} classNameHover1="infowidth" classNameHover2="infohover" text={info} />
            </ContInfo>}
            </LabelInfo>
        </Container>
    )
}
